export const column = [
    {
        label: '排序号',
        prop: 'sortNum'
    },
    {
        label: '轮播图名称',
        prop: 'pictureName'
    },
    {
        label: '轮播图',
        prop: 'pictureUrl'
    },
    {
        label: '链接地址',
        prop: 'pictureLink'
    },
    {
        label: '状态',
        prop: 'state'
    }
]